<template>
<v-card class="flex-row" flat tile width="100%" v-if="groupList.length">
    <v-card-text>
        <p class="text-h6 text--primary">
            {{title}}
            <v-btn color="primary" dark class="" @click="goToAllUsers()" :href="getGoToAllUsersUrl()" title="All Users">
                <v-icon>mdi-format-list-bulleted</v-icon>
            </v-btn>
        </p>
        <v-data-table @click:row="goToGroupView" v-if="groupList.length" :headers="headers" :items="groupList" :search="search" sort-by="weight_loss" :footer-props="{ 'items-per-page-options': [10, 20, 30, 50, 100, -1] }" :options="options">
            <template v-slot:[`item.actions`]="{ item }">
                <v-btn icon class="mr-2" @click="goToGroupView(item)" :href="getGoToGroupViewUrl(item)" title="Users">
                    <v-icon>
                        mdi-account-group
                    </v-icon>
                </v-btn>
            </template>
        </v-data-table>
    </v-card-text>
</v-card>
</template>

<script>
import formatData from "../utils/formatData";
export default {
    data() {
        return {
            title: 'Report',
            reportFilterData: {
                competition_id: '',
                startDate: '',
                endDate: ''
            },

            menu1: false,
            menu2: false,
            requiredRule: [
                v => !!v
            ],

            options: {
                itemsPerPage: 20,
            },
            search: "",
            headers: [{
                text: "Group Name (ID)",
                value: "name",
            }, 
            {
                text: "Members",
                value: "members",
                width: "100"
            },
            {
                text: "Weight Change (kg)",
                value: "weight_loss",
                width: "100"
            },
            {
                text: "Weight Change (%)",
                value: "weight_loss_percent",
                width: "100"
            },
            {
                text: "BMI Change",
                value: "bmi_changes",
                width: "100"
            }, 
            {
                text: "Steps",
                value: "steps_av",
                width: "100"
            },
            {
                text: "Distance",
                value: "distance_av",
                width: "100"
            }, 
            {
                text: "Exercise (mins)",
                value: "workout_minutes_av",
                width: "100"
            }, 
            {
                text: "Exercise (count)",
                value: "workout_number_av",
                width: "100"
            },  
            {
                text: "Servings",
                value: "servings_av",
                width: "100"
            }, 
            {
                text: "Points",
                value: "healthpoints_av",
                width: "100"
            }, 
            {
                text: "actions",
                value: "actions"
            } ],
            // groupList: [],
            isExporting: false,
        };
    },
    created() {
        // this.reportFilterData = this.$attrs.reportFilterData;
    },
    computed: {
        groupList(){
            return this.$attrs.reportData;
        },
        challengeId(){
            return this.$attrs.challengeId;
        }
    },
    methods: {
        _formatData(type, value) {
            return formatData(type, value);
        },
        formatDate(date) {
            if (!date) return null;

            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
        getTableHeader() {
            const text = [];
            for (let i = 0; i < this.headers.length; i++) {
                if( this.headers[i].text.indexOf('(Avg)') != -1 ){
                    text.push(this.headers[i].text);
                }
            }
            return text.join(', ');
        },
        //router
        goToChallengeList() {
            this.$router.push(`/challenge`);
        },
        goToGroupView(item) {
            this.$router.push(`/challenge/${this.challengeId}/${item.groupId}`);
        },
        getGoToGroupViewUrl(item) {
            return `/challenge/${this.challengeId}/${item.groupId}`;
        },
        goToAllUsers(){
            this.$router.push(`/challenge/${this.challengeId}/user`);
        },
        getGoToAllUsersUrl(){
            return `/challenge/${this.challengeId}/user`;
        }
    },
};
</script>
